import { takeLatest, select,call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";

const getCdExceptionsFromAPi = (id,token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/excecoes/cd/" + id, {
			method: "GET",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization":token
			},
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			if (error.response.status === 404) {
				const response = 404
				resolve(response);
			} else {
				reject(error);
				log.info(error);
			}
		});
	});
};

const postCdExceptionFromAPi = (id, date, description,token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/excecoes", {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization":token
			},
			data: {
				"idCd": id,
				"data": date,
				"descricao": description
			}
		})
		.then(response => response.status !== 201 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
	});
};

const deleteCdExceptionFromAPi = (id,token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/excecoes/" + id, {
			method: "DELETE",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization":token
			},
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
	});
};


//generators
function* getCdExceptions(payload) {

	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(getCdExceptionsFromAPi, payload.id,token);

		yield put({ type: "CD_EXCEPTIONS", payload: data });

	} catch (error) {
		//Este bloco em producao deverah ser melhor tratado e
		//apresentar uma mensagem para o cliente
		log.info(error);
	}

}

function* postCdException(payload) {

	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(postCdExceptionFromAPi, payload.id, payload.date, payload.description,token);

		yield put({ type: "CD_EXCEPTIONS_UPDATE", payload: data });

		yield put({ type: "CD_EXCEPTIONS_UPDATE", payload: null });

		yield put({ type: "SET_EXCEPTIONS_SUCCESS", payload:{ success: true, type: 'save' }});

	} catch (error) {
		yield put({ type: "SET_EXCEPTIONS_ERROR", payload:{ error: true, data: error }});	
		log.info(error);
	}

}

function* deleteCdException(payload) {

	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(deleteCdExceptionFromAPi, payload.id,token);

		yield put({ type: "CD_EXCEPTIONS_UPDATE", payload: data });

		yield put({ type: "CD_EXCEPTIONS_UPDATE", payload: null });

		yield put({ type: "SET_EXCEPTIONS_SUCCESS", payload:{ success: true, type: 'delete' }});

	} catch (error) {
		yield put({ type: "SET_EXCEPTIONS_ERROR", payload:{ error: true, data: error }});	
		log.info(error);
	}

}


// //Generator function
export function* getCdExceptionsWatcher() {
	yield takeLatest("GET_CD_EXCEPTIONS", getCdExceptions);
	yield takeLatest("POST_CD_EXCEPTION", postCdException);
	yield takeLatest("DELETE_CD_EXCEPTION", deleteCdException);
}
